import {
  INTELLIGENCE_HOME_DOT_IDLE_MS,
  INTELLIGENCE_LAST_VISIT_CACHE,
} from "./Config";

function storageKey(spaceId: string, spaceProductId: string): string {
  return `${INTELLIGENCE_LAST_VISIT_CACHE.keyPrefix}.v${INTELLIGENCE_LAST_VISIT_CACHE.version}:${spaceId}:${spaceProductId}`;
}

/** 记录当前时刻为情报社最近一次访问时间 */
export function markIntelLastVisit(spaceId: string, spaceProductId: string): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  const sid = spaceId.trim();
  const pid = spaceProductId.trim();
  if (!sid || !pid) {
    return;
  }
  try {
    localStorage.setItem(storageKey(sid, pid), String(Date.now()));
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * 首页金刚区是否展示情报社红点：从未访问，或距上次访问超过阈值。
 */
export function shouldShowIntelHomeDot(
  spaceId: string,
  spaceProductId: string,
  nowMs: number = Date.now()
): boolean {
  if (typeof localStorage === "undefined") {
    return false;
  }
  const sid = spaceId.trim();
  const pid = spaceProductId.trim();
  if (!sid || !pid) {
    return false;
  }
  const raw = localStorage.getItem(storageKey(sid, pid));
  if (!raw) {
    return true;
  }
  const last = Number(raw);
  if (!Number.isFinite(last) || last <= 0) {
    return true;
  }
  return nowMs - last >= INTELLIGENCE_HOME_DOT_IDLE_MS;
}
